import React from "react";

// Helpers
import cloneDeep from "lodash.clonedeep";

// Icons
import { PlusCircleIcon } from "@heroicons/react/24/outline";

import { TextIconUtilityButton } from "../Buttons/Buttons";

const NewPairButton = (props) => {
  const {
    comparisonItems,
    pairLimit,
    setComparisonItems,
    baseComparisonItem,
    newItemPrompt,
  } = props;

  return (
    <>
      {comparisonItems[comparisonItems.length - 1]["fileOne"][0] &&
        comparisonItems[comparisonItems.length - 1]["fileTwo"][0] &&
        comparisonItems.length < pairLimit && (
          <div className="flex flex-row items-center justify-end w-full">
            <TextIconUtilityButton
              Icon={PlusCircleIcon}
              prompt={newItemPrompt}
              iconSide={"right"}
              activeColor={"active:bg-green-100"}
              actionFunction={() => {
                setComparisonItems([
                  ...comparisonItems,
                  ...[cloneDeep(baseComparisonItem)],
                ]);
              }}
            />
          </div>
        )}
    </>
  );
};

export default NewPairButton;
